import { useCallback, useSyncExternalStore } from 'react';

import {
  beginWaitingForRocketReady,
  getRocketReadySnapshot,
  resetRocketReady,
  subscribeRocketReady,
} from './rocketReadyStore';

/**
 * Subscribes to Rocket iframe readiness via useSyncExternalStore.
 * When `iframeMounted` is false, readiness is forced false and any wait is cancelled
 * so a later remount re-runs the handshake.
 */
export function useRocketReadyForRequests(iframeMounted: boolean) {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      if (!iframeMounted) {
        resetRocketReady();
        return subscribeRocketReady(onStoreChange);
      }

      const unsubscribe = subscribeRocketReady(onStoreChange);
      beginWaitingForRocketReady();
      return () => {
        unsubscribe();
        resetRocketReady();
      };
    },
    [iframeMounted]
  );

  const getSnapshot = useCallback(
    () => (iframeMounted ? getRocketReadySnapshot() : false),
    [iframeMounted]
  );

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
